
export const StaffInputs = [
    {
      id: 1,
      label: "Username",
      type: "text",
      name:"username",
      variant : "standard",
      
      
    },
    {
      id: 2,
      label: "Email",
      type: "email",
      name:"email",
      variant : "standard",
    },
    {
      id: 3,
      label: "Phone",
      type: "text",
      name:"phone",
      variant : "standard",
      
    },
    {
      id: 4,
      label: "Password",
      type: "password",
      name:"password",
      variant : "standard",
      

    }
  ];
  


 

 

 
  
